import { t as Xe, c as ye, s as Ce, n as ft, b as Ve, d as W, a as mt, m as vt, o as pt, q as gt, r as It, v as Pt, D as xt, f as le, w as St, e as wt } from "./YLXVVG22.DAM5w7Mj.js";
import { c as De, d as T, a as te, f as ht, b as H, M as Je, u as Ze, _ as bt, k as ne, l as ee, g as L, x as ve, h as F, j as oe, z as se, J as Oe, m as pe, R as Et, t as Ae, T as ce, U as Ct, q as B, O as X, v as me, F as _e, V as yt, W as At, K as Fe, G as Qe, X as _t, Y as Dt, w as et, Z as Ot, P as Ft, $ as Tt, a0 as Re, i as Mt, p as Rt, a1 as kt, S as Lt, r as Nt, a2 as $t } from "./7FZLUSKW.7Pws8uOI.js";
import { createContext as ge, useRef as de, useEffect as $e, useState as tt, useCallback as Be, useContext as Bt, useMemo as rt } from "react";
import { f as Kt, h as nt, a as zt, b as Ht, u as Vt } from "./ZHUQ44XA.CPgwIBVH.js";
import { jsx as re } from "react/jsx-runtime";
import { d as Ut, c as Wt, o as jt, f as qt, s as Yt, l as Gt, a as Xt, b as Jt } from "./floating-ui.dom.DPeTK9V5.js";
import { c as Zt } from "./index.rKuIKazb.js";
import { L as Qt } from "./layout.BROMuy9M.js";
import '../assets/list-box-item.css';var Ie = De(), er = Ie.useContext;
Ie.useScopedContext;
Ie.useProviderContext;
var tr = Ie.ContextProvider, rr = Ie.ScopedContextProvider, Pe = De(
  [tr],
  [rr]
), ot = Pe.useContext;
Pe.useScopedContext;
var nr = Pe.useProviderContext, st = Pe.ContextProvider, or = Pe.ScopedContextProvider, sr = ge(
  void 0
), ir = ge(
  void 0
);
function ar(t, r) {
  return !!(r.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_PRECEDING);
}
function ur(t) {
  const r = t.map((e, o) => [o, e]);
  let n = !1;
  return r.sort(([e, o], [a, c]) => {
    const d = o.element, s = c.element;
    return d === s || !d || !s ? 0 : ar(d, s) ? (e > a && (n = !0), -1) : (e < a && (n = !0), 1);
  }), n ? r.map(([e, o]) => o) : t;
}
function lr(t) {
  var r;
  const n = t.find((a) => !!a.element), e = [...t].reverse().find((a) => !!a.element);
  let o = (r = n == null ? void 0 : n.element) == null ? void 0 : r.parentElement;
  for (; o && (e != null && e.element); ) {
    if (e && o.contains(e.element))
      return o;
    o = o.parentElement;
  }
  return Je(o).body;
}
function cr(t) {
  return t == null ? void 0 : t.__unstablePrivateStore;
}
function dr(t = {}) {
  var r;
  Xe(t, t.store);
  const n = (r = t.store) == null ? void 0 : r.getState(), e = T(
    t.items,
    n == null ? void 0 : n.items,
    t.defaultItems,
    []
  ), o = new Map(e.map((l) => [l.id, l])), a = {
    items: e,
    renderedItems: T(n == null ? void 0 : n.renderedItems, [])
  }, c = cr(t.store), d = ye(
    { items: e, renderedItems: a.renderedItems },
    c
  ), s = ye(a, t.store), v = (l) => {
    const f = ur(l);
    d.setState("renderedItems", f), s.setState("renderedItems", f);
  };
  Ce(s, () => ft(d)), Ce(d, () => Ve(d, ["items"], (l) => {
    s.setState("items", l.items);
  })), Ce(d, () => Ve(d, ["renderedItems"], (l) => {
    let f = !0, P = requestAnimationFrame(() => {
      const { renderedItems: b } = s.getState();
      l.renderedItems !== b && v(l.renderedItems);
    });
    if (typeof IntersectionObserver != "function")
      return () => cancelAnimationFrame(P);
    const I = () => {
      if (f) {
        f = !1;
        return;
      }
      cancelAnimationFrame(P), P = requestAnimationFrame(() => v(l.renderedItems));
    }, x = lr(l.renderedItems), h = new IntersectionObserver(I, { root: x });
    for (const b of l.renderedItems)
      b.element && h.observe(b.element);
    return () => {
      cancelAnimationFrame(P), h.disconnect();
    };
  }));
  const m = (l, f, P = !1) => {
    let I;
    return f((h) => {
      const b = h.findIndex(({ id: _ }) => _ === l.id), M = h.slice();
      if (b !== -1) {
        I = h[b];
        const _ = H(H({}, I), l);
        M[b] = _, o.set(l.id, _);
      } else
        M.push(l), o.set(l.id, l);
      return M;
    }), () => {
      f((h) => {
        if (!I)
          return P && o.delete(l.id), h.filter(({ id: _ }) => _ !== l.id);
        const b = h.findIndex(({ id: _ }) => _ === l.id);
        if (b === -1) return h;
        const M = h.slice();
        return M[b] = I, o.set(l.id, I), M;
      });
    };
  }, p = (l) => m(
    l,
    (f) => d.setState("items", f),
    !0
  );
  return te(H({}, s), {
    registerItem: p,
    renderItem: (l) => ht(
      p(l),
      m(
        l,
        (f) => d.setState("renderedItems", f)
      )
    ),
    item: (l) => {
      if (!l) return null;
      let f = o.get(l);
      if (!f) {
        const { items: P } = s.getState();
        f = P.find((I) => I.id === l), f && o.set(l, f);
      }
      return f || null;
    },
    // @ts-expect-error Internal
    __unstablePrivateStore: d
  });
}
function fr(t, r, n) {
  return Ze(r, [n.store]), W(t, n, "items", "setItems"), t;
}
function In(t) {
  return Array.isArray(t) ? t : typeof t < "u" ? [t] : [];
}
function it(t) {
  const r = [];
  for (const n of t)
    r.push(...n);
  return r;
}
function ke(t) {
  return t.slice().reverse();
}
var mr = { id: null };
function G(t, r) {
  return t.find((n) => r ? !n.disabled && n.id !== r : !n.disabled);
}
function vr(t, r) {
  return t.filter((n) => r ? !n.disabled && n.id !== r : !n.disabled);
}
function Ue(t, r) {
  return t.filter((n) => n.rowId === r);
}
function pr(t, r, n = !1) {
  const e = t.findIndex((o) => o.id === r);
  return [
    ...t.slice(e + 1),
    ...n ? [mr] : [],
    ...t.slice(0, e)
  ];
}
function at(t) {
  const r = [];
  for (const n of t) {
    const e = r.find((o) => {
      var a;
      return ((a = o[0]) == null ? void 0 : a.rowId) === n.rowId;
    });
    e ? e.push(n) : r.push([n]);
  }
  return r;
}
function ut(t) {
  let r = 0;
  for (const { length: n } of t)
    n > r && (r = n);
  return r;
}
function gr(t) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: !0,
    rowId: t
  };
}
function Ir(t, r, n) {
  const e = ut(t);
  for (const o of t)
    for (let a = 0; a < e; a += 1) {
      const c = o[a];
      if (!c || n && c.disabled) {
        const s = a === 0 && n ? G(o) : o[a - 1];
        o[a] = s && r !== s.id && n ? s : gr(s == null ? void 0 : s.rowId);
      }
    }
  return t;
}
function Pr(t) {
  const r = at(t), n = ut(r), e = [];
  for (let o = 0; o < n; o += 1)
    for (const a of r) {
      const c = a[o];
      c && e.push(te(H({}, c), {
        // If there's no rowId, it means that it's not a grid composite, but
        // a single row instead. So, instead of verticalizing it, that is,
        // assigning a different rowId based on the column index, we keep it
        // undefined so they will be part of the same row. This is useful
        // when using up/down on one-dimensional composites.
        rowId: c.rowId ? `${o}` : void 0
      }));
    }
  return e;
}
function Pn(t = {}) {
  var r;
  const n = (r = t.store) == null ? void 0 : r.getState(), e = dr(t), o = T(
    t.activeId,
    n == null ? void 0 : n.activeId,
    t.defaultActiveId
  ), a = te(H({}, e.getState()), {
    activeId: o,
    baseElement: T(n == null ? void 0 : n.baseElement, null),
    includesBaseElement: T(
      t.includesBaseElement,
      n == null ? void 0 : n.includesBaseElement,
      o === null
    ),
    moves: T(n == null ? void 0 : n.moves, 0),
    orientation: T(
      t.orientation,
      n == null ? void 0 : n.orientation,
      "both"
    ),
    rtl: T(t.rtl, n == null ? void 0 : n.rtl, !1),
    virtualFocus: T(
      t.virtualFocus,
      n == null ? void 0 : n.virtualFocus,
      !1
    ),
    focusLoop: T(t.focusLoop, n == null ? void 0 : n.focusLoop, !1),
    focusWrap: T(t.focusWrap, n == null ? void 0 : n.focusWrap, !1),
    focusShift: T(t.focusShift, n == null ? void 0 : n.focusShift, !1)
  }), c = ye(a, e, t.store);
  Ce(
    c,
    () => mt(c, ["renderedItems", "activeId"], (s) => {
      c.setState("activeId", (v) => {
        var m;
        return v !== void 0 ? v : (m = G(s.renderedItems)) == null ? void 0 : m.id;
      });
    })
  );
  const d = (s = "next", v = {}) => {
    var m, p;
    const l = c.getState(), {
      skip: f = 0,
      activeId: P = l.activeId,
      focusShift: I = l.focusShift,
      focusLoop: x = l.focusLoop,
      focusWrap: h = l.focusWrap,
      includesBaseElement: b = l.includesBaseElement,
      renderedItems: M = l.renderedItems,
      rtl: _ = l.rtl
    } = v, E = s === "up" || s === "down", j = s === "next" || s === "down", V = j ? _ && !E : !_ || E, U = I && !f;
    let A = E ? it(
      Ir(at(M), P, U)
    ) : M;
    if (A = V ? ke(A) : A, A = E ? Pr(A) : A, P == null)
      return (m = G(A)) == null ? void 0 : m.id;
    const C = A.find((i) => i.id === P);
    if (!C)
      return (p = G(A)) == null ? void 0 : p.id;
    const K = A.some((i) => i.rowId), J = A.indexOf(C), u = A.slice(J + 1), S = Ue(u, C.rowId);
    if (f) {
      const i = vr(S, P), g = i.slice(f)[0] || // If we can't find an item, just return the last one.
      i[i.length - 1];
      return g == null ? void 0 : g.id;
    }
    const y = x && (E ? x !== "horizontal" : x !== "vertical"), D = K && h && (E ? h !== "horizontal" : h !== "vertical"), O = j ? (!K || E) && y && b : E ? b : !1;
    if (y) {
      const i = D && !O ? A : Ue(A, C.rowId), g = pr(i, P, O), w = G(g, P);
      return w == null ? void 0 : w.id;
    }
    if (D) {
      const i = G(
        // We can use nextItems, which contains all the next items, including
        // items from other rows, to wrap between rows. However, if there is a
        // null item (the composite container), we'll only use the next items in
        // the row. So moving next from the last item will focus on the
        // composite container. On grid composites, horizontal navigation never
        // focuses on the composite container, only vertical.
        O ? S : u,
        P
      );
      return O ? (i == null ? void 0 : i.id) || null : i == null ? void 0 : i.id;
    }
    const k = G(S, P);
    return !k && O ? null : k == null ? void 0 : k.id;
  };
  return te(H(H({}, e), c), {
    setBaseElement: (s) => c.setState("baseElement", s),
    setActiveId: (s) => c.setState("activeId", s),
    move: (s) => {
      s !== void 0 && (c.setState("activeId", s), c.setState("moves", (v) => v + 1));
    },
    first: () => {
      var s;
      return (s = G(c.getState().renderedItems)) == null ? void 0 : s.id;
    },
    last: () => {
      var s;
      return (s = G(ke(c.getState().renderedItems))) == null ? void 0 : s.id;
    },
    next: (s) => (s !== void 0 && typeof s == "number" && (s = { skip: s }), d("next", s)),
    previous: (s) => (s !== void 0 && typeof s == "number" && (s = { skip: s }), d("previous", s)),
    down: (s) => (s !== void 0 && typeof s == "number" && (s = { skip: s }), d("down", s)),
    up: (s) => (s !== void 0 && typeof s == "number" && (s = { skip: s }), d("up", s))
  });
}
function xn(t, r, n) {
  return t = fr(t, r, n), W(t, n, "activeId", "setActiveId"), W(t, n, "includesBaseElement"), W(t, n, "virtualFocus"), W(t, n, "orientation"), W(t, n, "rtl"), W(t, n, "focusLoop"), W(t, n, "focusWrap"), W(t, n, "focusShift"), t;
}
function Sn(t = {}) {
  var r = t, {
    popover: n
  } = r, e = bt(r, [
    "popover"
  ]);
  const o = vt(
    e.store,
    pt(n, [
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  Xe(e, o);
  const a = o == null ? void 0 : o.getState(), c = gt(te(H({}, e), { store: o })), d = T(
    e.placement,
    a == null ? void 0 : a.placement,
    "bottom"
  ), s = te(H({}, c.getState()), {
    placement: d,
    currentPlacement: d,
    anchorElement: T(a == null ? void 0 : a.anchorElement, null),
    popoverElement: T(a == null ? void 0 : a.popoverElement, null),
    arrowElement: T(a == null ? void 0 : a.arrowElement, null),
    rendered: Symbol("rendered")
  }), v = ye(s, c, o);
  return te(H(H({}, c), v), {
    setAnchorElement: (m) => v.setState("anchorElement", m),
    setPopoverElement: (m) => v.setState("popoverElement", m),
    setArrowElement: (m) => v.setState("arrowElement", m),
    render: () => v.setState("rendered", Symbol("rendered"))
  });
}
function wn(t, r, n) {
  return Ze(r, [n.popover]), W(t, n, "placement"), It(t, r, n);
}
var xe = De(
  [xt],
  [Pt]
), xr = xe.useContext;
xe.useScopedContext;
var Ke = xe.useProviderContext, Sr = xe.ContextProvider, lt = xe.ScopedContextProvider, hn = ge(
  void 0
), Se = De(
  [Sr, st],
  [lt, or]
), bn = Se.useContext, En = Se.useScopedContext, Cn = Se.useProviderContext, yn = Se.ContextProvider, An = Se.ScopedContextProvider, _n = ge(
  void 0
), Dn = ge(!1), wr = "div", hr = ne(
  function(r) {
    var n = r, { store: e } = n, o = ee(n, ["store"]);
    const a = Ke();
    return e = e || a, o = L(F({}, o), {
      ref: ve(e == null ? void 0 : e.setAnchorElement, o.ref)
    }), o;
  }
);
oe(function(r) {
  const n = hr(r);
  return se(wr, n);
});
var br = { id: null };
function On(t, r, n = !1) {
  const e = t.findIndex((o) => o.id === r);
  return [
    ...t.slice(e + 1),
    ...n ? [br] : [],
    ...t.slice(0, e)
  ];
}
function Er(t, r) {
  return t.find((n) => !n.disabled);
}
function Q(t, r) {
  return r && t.item(r) || null;
}
function Cr(t) {
  const r = [];
  for (const n of t) {
    const e = r.find((o) => {
      var a;
      return ((a = o[0]) == null ? void 0 : a.rowId) === n.rowId;
    });
    e ? e.push(n) : r.push([n]);
  }
  return r;
}
function yr(t, r = !1) {
  if (Oe(t))
    t.setSelectionRange(
      r ? t.value.length : 0,
      t.value.length
    );
  else if (t.isContentEditable) {
    const n = Je(t).getSelection();
    n == null || n.selectAllChildren(t), r && (n == null || n.collapseToEnd());
  }
}
var Le = Symbol("FOCUS_SILENTLY");
function Ar(t) {
  t[Le] = !0, t.focus({ preventScroll: !0 });
}
function _r(t) {
  const r = t[Le];
  return delete t[Le], r;
}
function fe(t, r, n) {
  return !(!r || r === n || !t.item(r.id));
}
var Dr = "div";
function Or(t) {
  return t.some((r) => !!r.rowId);
}
function Fr(t) {
  const r = t.target;
  return r && !Oe(r) ? !1 : t.key.length === 1 && !t.ctrlKey && !t.metaKey;
}
function Tr(t) {
  return t.key === "Shift" || t.key === "Control" || t.key === "Alt" || t.key === "Meta";
}
function We(t, r, n) {
  return B((e) => {
    var o;
    if (r == null || r(e), e.defaultPrevented || e.isPropagationStopped() || !X(e) || Tr(e) || Fr(e)) return;
    const a = t.getState(), c = (o = Q(t, a.activeId)) == null ? void 0 : o.element;
    if (!c) return;
    const d = e, s = ee(d, ["view"]), v = n == null ? void 0 : n.current;
    c !== v && c.focus(), yt(c, e.type, s) || e.preventDefault(), e.currentTarget.contains(c) && e.stopPropagation();
  });
}
function Mr(t) {
  return Er(
    it(ke(Cr(t)))
  );
}
function Rr(t) {
  const [r, n] = tt(!1), e = Be(() => n(!0), []), o = t.useState(
    (a) => Q(t, a.activeId)
  );
  return $e(() => {
    const a = o == null ? void 0 : o.element;
    r && a && (n(!1), a.focus({ preventScroll: !0 }));
  }, [o, r]), e;
}
var kr = ne(
  function(r) {
    var n = r, {
      store: e,
      composite: o = !0,
      focusOnMove: a = o,
      moveOnKeyPress: c = !0
    } = n, d = ee(n, [
      "store",
      "composite",
      "focusOnMove",
      "moveOnKeyPress"
    ]);
    const s = nr();
    e = e || s, pe(
      e,
      process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component."
    );
    const v = de(null), m = de(null), p = Rr(e), l = e.useState("moves"), [, f] = Et(
      o ? e.setBaseElement : null
    );
    $e(() => {
      var u;
      if (!e || !l || !o || !a) return;
      const { activeId: S } = e.getState(), y = (u = Q(e, S)) == null ? void 0 : u.element;
      y && Kt(y);
    }, [e, l, o, a]), Ae(() => {
      if (!e || !l || !o) return;
      const { baseElement: u, activeId: S } = e.getState();
      if (!(S === null) || !u) return;
      const D = m.current;
      m.current = null, D && ce(D, { relatedTarget: u }), nt(u) || u.focus();
    }, [e, l, o]);
    const P = e.useState("activeId"), I = e.useState("virtualFocus");
    Ae(() => {
      var u;
      if (!e || !o || !I) return;
      const S = m.current;
      if (m.current = null, !S) return;
      const D = ((u = Q(e, P)) == null ? void 0 : u.element) || Ct(S);
      D !== S && ce(S, { relatedTarget: D });
    }, [e, P, I, o]);
    const x = We(
      e,
      d.onKeyDownCapture,
      m
    ), h = We(
      e,
      d.onKeyUpCapture,
      m
    ), b = d.onFocusCapture, M = B((u) => {
      if (b == null || b(u), u.defaultPrevented || !e) return;
      const { virtualFocus: S } = e.getState();
      if (!S) return;
      const y = u.relatedTarget, D = _r(u.currentTarget);
      X(u) && D && (u.stopPropagation(), m.current = y);
    }), _ = d.onFocus, E = B((u) => {
      if (_ == null || _(u), u.defaultPrevented || !o || !e) return;
      const { relatedTarget: S } = u, { virtualFocus: y } = e.getState();
      y ? X(u) && !fe(e, S) && queueMicrotask(p) : X(u) && e.setActiveId(null);
    }), j = d.onBlurCapture, V = B((u) => {
      var S;
      if (j == null || j(u), u.defaultPrevented || !e) return;
      const { virtualFocus: y, activeId: D } = e.getState();
      if (!y) return;
      const O = (S = Q(e, D)) == null ? void 0 : S.element, k = u.relatedTarget, i = fe(e, k), g = m.current;
      m.current = null, X(u) && i ? (k === O ? g && g !== k && ce(g, u) : O ? ce(O, u) : g && ce(g, u), u.stopPropagation()) : !fe(e, u.target) && O && ce(O, u);
    }), U = d.onKeyDown, A = me(c), C = B((u) => {
      var S;
      if (U == null || U(u), u.defaultPrevented || !e || !X(u)) return;
      const { orientation: y, items: D, renderedItems: O, activeId: k } = e.getState(), i = Q(e, k);
      if ((S = i == null ? void 0 : i.element) != null && S.isConnected) return;
      const g = y !== "horizontal", w = y !== "vertical", N = Or(O);
      if ((u.key === "ArrowLeft" || u.key === "ArrowRight" || u.key === "Home" || u.key === "End") && Oe(u.currentTarget)) return;
      const ie = {
        ArrowUp: (N || g) && (() => {
          if (N) {
            const Z = D && Mr(D);
            return Z == null ? void 0 : Z.id;
          }
          return e == null ? void 0 : e.last();
        }),
        ArrowRight: (N || w) && e.first,
        ArrowDown: (N || g) && e.first,
        ArrowLeft: (N || w) && e.last,
        Home: e.first,
        End: e.last,
        PageUp: e.first,
        PageDown: e.last
      }[u.key];
      if (ie) {
        const Z = ie();
        if (Z !== void 0) {
          if (!A(u)) return;
          u.preventDefault(), e.move(Z);
        }
      }
    });
    d = _e(
      d,
      (u) => /* @__PURE__ */ re(st, { value: e, children: u }),
      [e]
    );
    const K = e.useState((u) => {
      var S;
      if (e && o && u.virtualFocus)
        return (S = Q(e, u.activeId)) == null ? void 0 : S.id;
    });
    d = L(F({
      "aria-activedescendant": K
    }, d), {
      ref: ve(v, f, d.ref),
      onKeyDownCapture: x,
      onKeyUpCapture: h,
      onFocusCapture: M,
      onFocus: E,
      onBlurCapture: V,
      onKeyDown: C
    });
    const J = e.useState(
      (u) => o && (u.virtualFocus || u.activeId === null)
    );
    return d = zt(F({ focusable: J }, d)), d;
  }
);
oe(function(r) {
  const n = kr(r);
  return se(Dr, n);
});
var Lr = "div";
function ct(t) {
  const r = t.relatedTarget;
  return (r == null ? void 0 : r.nodeType) === Node.ELEMENT_NODE ? r : null;
}
function Nr(t) {
  const r = ct(t);
  return r ? _t(t.currentTarget, r) : !1;
}
var Ne = Symbol("composite-hover");
function $r(t) {
  let r = ct(t);
  if (!r) return !1;
  do {
    if (Dt(r, Ne) && r[Ne]) return !0;
    r = r.parentElement;
  } while (r);
  return !1;
}
var Br = ne(
  function(r) {
    var n = r, {
      store: e,
      focusOnHover: o = !0,
      blurOnHoverEnd: a = !!o
    } = n, c = ee(n, [
      "store",
      "focusOnHover",
      "blurOnHoverEnd"
    ]);
    const d = ot();
    e = e || d, pe(
      e,
      process.env.NODE_ENV !== "production" && "CompositeHover must be wrapped in a Composite component."
    );
    const s = At(), v = c.onMouseMove, m = me(o), p = B((x) => {
      if (v == null || v(x), !x.defaultPrevented && s() && m(x)) {
        if (!Ht(x.currentTarget)) {
          const h = e == null ? void 0 : e.getState().baseElement;
          h && !nt(h) && h.focus();
        }
        e == null || e.setActiveId(x.currentTarget.id);
      }
    }), l = c.onMouseLeave, f = me(a), P = B((x) => {
      var h;
      l == null || l(x), !x.defaultPrevented && s() && (Nr(x) || $r(x) || m(x) && f(x) && (e == null || e.setActiveId(null), (h = e == null ? void 0 : e.getState().baseElement) == null || h.focus()));
    }), I = Be((x) => {
      x && (x[Ne] = !0);
    }, []);
    return c = L(F({}, c), {
      ref: ve(I, c.ref),
      onMouseMove: p,
      onMouseLeave: P
    }), Fe(c);
  }
);
Qe(
  oe(function(r) {
    const n = Br(r);
    return se(Lr, n);
  })
);
var Kr = "div", dt = ne(
  function(r) {
    var n = r, {
      store: e,
      shouldRegisterItem: o = !0,
      getItem: a = Ot,
      element: c
    } = n, d = ee(n, [
      "store",
      "shouldRegisterItem",
      "getItem",
      // @ts-expect-error This prop may come from a collection renderer.
      "element"
    ]);
    const s = er();
    e = e || s;
    const v = et(d.id), m = de(c);
    return $e(() => {
      const p = m.current;
      if (!v || !p || !o) return;
      const l = a({ id: v, element: p });
      return e == null ? void 0 : e.renderItem(l);
    }, [v, o, a, e]), d = L(F({}, d), {
      ref: ve(m, d.ref)
    }), Fe(d);
  }
);
oe(function(r) {
  const n = dt(r);
  return se(Kr, n);
});
var zr = "button";
function Hr(t) {
  return Re(t) ? !0 : t.tagName === "INPUT" && !Lt(t);
}
function Vr(t, r = !1) {
  const n = t.clientHeight, { top: e } = t.getBoundingClientRect(), o = Math.max(n * 0.875, n - 40) * 1.5, a = r ? n - o + e : o + e;
  return t.tagName === "HTML" ? a + t.scrollTop : a;
}
function Ur(t, r = !1) {
  const { top: n } = t.getBoundingClientRect();
  return r ? n + t.clientHeight : n;
}
function je(t, r, n, e = !1) {
  var o;
  if (!r || !n) return;
  const { renderedItems: a } = r.getState(), c = Nt(t);
  if (!c) return;
  const d = Vr(c, e);
  let s, v;
  for (let m = 0; m < a.length; m += 1) {
    const p = s;
    if (s = n(m), !s) break;
    if (s === p) continue;
    const l = (o = Q(r, s)) == null ? void 0 : o.element;
    if (!l) continue;
    const P = Ur(l, e) - d, I = Math.abs(P);
    if (e && P <= 0 || !e && P >= 0) {
      v !== void 0 && v < I && (s = p);
      break;
    }
    v = I;
  }
  return s;
}
function Wr(t, r) {
  return X(t) ? !1 : fe(r, t.target);
}
var jr = ne(
  function(r) {
    var n = r, {
      store: e,
      rowId: o,
      preventScrollOnKeyDown: a = !1,
      moveOnKeyPress: c = !0,
      tabbable: d = !1,
      getItem: s,
      "aria-setsize": v,
      "aria-posinset": m
    } = n, p = ee(n, [
      "store",
      "rowId",
      "preventScrollOnKeyDown",
      "moveOnKeyPress",
      "tabbable",
      "getItem",
      "aria-setsize",
      "aria-posinset"
    ]);
    const l = ot();
    e = e || l;
    const f = et(p.id), P = de(null), I = Bt(ir), x = le(e, (i) => {
      if (o) return o;
      if (i && I != null && I.baseElement && I.baseElement === i.baseElement)
        return I.id;
    }), b = Ft(p) && !p.accessibleWhenDisabled, M = Be(
      (i) => {
        const g = L(F({}, i), {
          id: f || i.id,
          rowId: x,
          disabled: !!b
        });
        return s ? s(g) : g;
      },
      [f, x, b, s]
    ), _ = p.onFocus, E = de(!1), j = B((i) => {
      if (_ == null || _(i), i.defaultPrevented || Tt(i) || !f || !e || Wr(i, e)) return;
      const { virtualFocus: g, baseElement: w } = e.getState();
      if (e.setActiveId(f), Re(i.currentTarget) && yr(i.currentTarget), !g || !X(i) || Hr(i.currentTarget) || !(w != null && w.isConnected)) return;
      Mt() && i.currentTarget.hasAttribute("data-autofocus") && i.currentTarget.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      }), E.current = !0, i.relatedTarget === w || fe(e, i.relatedTarget) ? Ar(w) : w.focus();
    }), V = p.onBlurCapture, U = B((i) => {
      if (V == null || V(i), i.defaultPrevented) return;
      const g = e == null ? void 0 : e.getState();
      g != null && g.virtualFocus && E.current && (E.current = !1, i.preventDefault(), i.stopPropagation());
    }), A = p.onKeyDown, C = me(a), K = me(c), J = B((i) => {
      if (A == null || A(i), i.defaultPrevented || !X(i) || !e) return;
      const { currentTarget: g } = i, w = e.getState(), N = e.item(f), z = !!(N != null && N.rowId), R = w.orientation !== "horizontal", $ = w.orientation !== "vertical", ie = () => !!(z || $ || !w.baseElement || !Oe(w.baseElement)), q = {
        ArrowUp: (z || R) && e.up,
        ArrowRight: (z || $) && e.next,
        ArrowDown: (z || R) && e.down,
        ArrowLeft: (z || $) && e.previous,
        Home: () => {
          if (ie())
            return !z || i.ctrlKey ? e == null ? void 0 : e.first() : e == null ? void 0 : e.previous(-1);
        },
        End: () => {
          if (ie())
            return !z || i.ctrlKey ? e == null ? void 0 : e.last() : e == null ? void 0 : e.next(-1);
        },
        PageUp: () => je(g, e, e == null ? void 0 : e.up, !0),
        PageDown: () => je(g, e, e == null ? void 0 : e.down)
      }[i.key];
      if (q) {
        if (Re(g)) {
          const Y = Rt(g), Te = $ && i.key === "ArrowLeft", Me = $ && i.key === "ArrowRight", ae = R && i.key === "ArrowUp", ue = R && i.key === "ArrowDown";
          if (Me || ue) {
            const { length: he } = kt(g);
            if (Y.end !== he) return;
          } else if ((Te || ae) && Y.start !== 0) return;
        }
        const we = q();
        if (C(i) || we !== void 0) {
          if (!K(i)) return;
          i.preventDefault(), e.move(we);
        }
      }
    }), u = le(
      e,
      (i) => (i == null ? void 0 : i.baseElement) || void 0
    ), S = rt(
      () => ({ id: f, baseElement: u }),
      [f, u]
    );
    p = _e(
      p,
      (i) => /* @__PURE__ */ re(sr.Provider, { value: S, children: i }),
      [S]
    );
    const y = le(
      e,
      (i) => !!i && i.activeId === f
    ), D = le(e, (i) => {
      if (v != null) return v;
      if (i && I != null && I.ariaSetSize && I.baseElement === i.baseElement)
        return I.ariaSetSize;
    }), O = le(e, (i) => {
      if (m != null) return m;
      if (!i || !(I != null && I.ariaPosInSet) || I.baseElement !== i.baseElement) return;
      const g = i.renderedItems.filter(
        (w) => w.rowId === x
      );
      return I.ariaPosInSet + g.findIndex((w) => w.id === f);
    }), k = le(e, (i) => {
      var g;
      if (!(i != null && i.renderedItems.length)) return !0;
      if (i.virtualFocus) return !1;
      if (d) return !0;
      if (i.activeId === null) return !1;
      const w = e == null ? void 0 : e.item(i.activeId);
      return w != null && w.disabled || !((g = w == null ? void 0 : w.element) != null && g.isConnected) ? !0 : i.activeId === f;
    });
    return p = L(F({
      id: f,
      "data-active-item": y || void 0
    }, p), {
      ref: ve(P, p.ref),
      tabIndex: k ? p.tabIndex : -1,
      onFocus: j,
      onBlurCapture: U,
      onKeyDown: J
    }), p = Vt(p), p = dt(L(F({
      store: e
    }, p), {
      getItem: M,
      shouldRegisterItem: f ? p.shouldRegisterItem : !1
    })), Fe(L(F({}, p), {
      "aria-setsize": D,
      "aria-posinset": O
    }));
  }
);
Qe(
  oe(function(r) {
    const n = jr(r);
    return se(zr, n);
  })
);
var qr = "div";
function qe(t = 0, r = 0, n = 0, e = 0) {
  if (typeof DOMRect == "function")
    return new DOMRect(t, r, n, e);
  const o = {
    x: t,
    y: r,
    width: n,
    height: e,
    top: r,
    right: t + n,
    bottom: r + e,
    left: t
  };
  return L(F({}, o), { toJSON: () => o });
}
function Yr(t) {
  if (!t) return qe();
  const { x: r, y: n, width: e, height: o } = t;
  return qe(r, n, e, o);
}
function Gr(t, r) {
  return {
    contextElement: t || void 0,
    getBoundingClientRect: () => {
      const e = t, o = r == null ? void 0 : r(e);
      return o || !e ? Yr(o) : e.getBoundingClientRect();
    }
  };
}
function Xr(t) {
  return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(t);
}
function Ye(t) {
  const r = window.devicePixelRatio || 1;
  return Math.round(t * r) / r;
}
function Jr(t, r) {
  return jt(({ placement: n }) => {
    var e;
    const o = ((t == null ? void 0 : t.clientHeight) || 0) / 2, a = typeof r.gutter == "number" ? r.gutter + o : (e = r.gutter) != null ? e : o;
    return {
      crossAxis: !!n.split("-")[1] ? void 0 : r.shift,
      mainAxis: a,
      alignmentAxis: r.shift
    };
  });
}
function Zr(t) {
  if (t.flip === !1) return;
  const r = typeof t.flip == "string" ? t.flip.split(" ") : void 0;
  return pe(
    !r || r.every(Xr),
    process.env.NODE_ENV !== "production" && "`flip` expects a spaced-delimited list of placements"
  ), qt({
    padding: t.overflowPadding,
    fallbackPlacements: r
  });
}
function Qr(t) {
  if (!(!t.slide && !t.overlap))
    return Yt({
      mainAxis: t.slide,
      crossAxis: t.overlap,
      padding: t.overflowPadding,
      limiter: Gt()
    });
}
function en(t) {
  return Xt({
    padding: t.overflowPadding,
    apply({ elements: r, availableWidth: n, availableHeight: e, rects: o }) {
      const a = r.floating, c = Math.round(o.reference.width);
      n = Math.floor(n), e = Math.floor(e), a.style.setProperty(
        "--popover-anchor-width",
        `${c}px`
      ), a.style.setProperty(
        "--popover-available-width",
        `${n}px`
      ), a.style.setProperty(
        "--popover-available-height",
        `${e}px`
      ), t.sameWidth && (a.style.width = `${c}px`), t.fitViewport && (a.style.maxWidth = `${n}px`, a.style.maxHeight = `${e}px`);
    }
  });
}
function tn(t, r) {
  if (t)
    return Jt({
      element: t,
      padding: r.arrowPadding
    });
}
var rn = ne(
  function(r) {
    var n = r, {
      store: e,
      modal: o = !1,
      portal: a = !!o,
      preserveTabOrder: c = !0,
      autoFocusOnShow: d = !0,
      wrapperProps: s,
      fixed: v = !1,
      flip: m = !0,
      shift: p = 0,
      slide: l = !0,
      overlap: f = !1,
      sameWidth: P = !1,
      fitViewport: I = !1,
      gutter: x,
      arrowPadding: h = 4,
      overflowPadding: b = 8,
      getAnchorRect: M,
      updatePosition: _
    } = n, E = ee(n, [
      "store",
      "modal",
      "portal",
      "preserveTabOrder",
      "autoFocusOnShow",
      "wrapperProps",
      "fixed",
      "flip",
      "shift",
      "slide",
      "overlap",
      "sameWidth",
      "fitViewport",
      "gutter",
      "arrowPadding",
      "overflowPadding",
      "getAnchorRect",
      "updatePosition"
    ]);
    const j = Ke();
    e = e || j, pe(
      e,
      process.env.NODE_ENV !== "production" && "Popover must receive a `store` prop or be wrapped in a PopoverProvider component."
    );
    const V = e.useState("arrowElement"), U = e.useState("anchorElement"), A = e.useState("disclosureElement"), C = e.useState("popoverElement"), K = e.useState("contentElement"), J = e.useState("placement"), u = e.useState("mounted"), S = e.useState("rendered"), y = de(null), [D, O] = tt(!1), { portalRef: k, domReady: i } = $t(a, E.portalRef), g = B(M), w = B(_), N = !!_;
    Ae(() => {
      if (!(C != null && C.isConnected)) return;
      C.style.setProperty(
        "--popover-overflow-padding",
        `${b}px`
      );
      const R = Gr(U, g), $ = async () => {
        if (!u) return;
        V || (y.current = y.current || document.createElement("div"));
        const q = V || y.current, we = [
          Jr(q, { gutter: x, shift: p }),
          Zr({ flip: m, overflowPadding: b }),
          Qr({ slide: l, shift: p, overlap: f, overflowPadding: b }),
          tn(q, { arrowPadding: h }),
          en({
            sameWidth: P,
            fitViewport: I,
            overflowPadding: b
          })
        ], Y = await Wt(R, C, {
          placement: J,
          strategy: v ? "fixed" : "absolute",
          middleware: we
        });
        e == null || e.setState("currentPlacement", Y.placement), O(!0);
        const Te = Ye(Y.x), Me = Ye(Y.y);
        if (Object.assign(C.style, {
          top: "0",
          left: "0",
          transform: `translate3d(${Te}px,${Me}px,0)`
        }), q && Y.middlewareData.arrow) {
          const { x: ae, y: ue } = Y.middlewareData.arrow, he = Y.placement.split("-")[0], be = q.clientWidth / 2, Ee = q.clientHeight / 2, ze = ae != null ? ae + be : -be, He = ue != null ? ue + Ee : -Ee;
          C.style.setProperty(
            "--popover-transform-origin",
            {
              top: `${ze}px calc(100% + ${Ee}px)`,
              bottom: `${ze}px ${-Ee}px`,
              left: `calc(100% + ${be}px) ${He}px`,
              right: `${-be}px ${He}px`
            }[he]
          ), Object.assign(q.style, {
            left: ae != null ? `${ae}px` : "",
            top: ue != null ? `${ue}px` : "",
            [he]: "100%"
          });
        }
      }, Z = Ut(R, C, async () => {
        N ? (await w({ updatePosition: $ }), O(!0)) : await $();
      }, {
        // JSDOM doesn't support ResizeObserver
        elementResize: typeof ResizeObserver == "function"
      });
      return () => {
        O(!1), Z();
      };
    }, [
      e,
      S,
      C,
      V,
      U,
      C,
      J,
      u,
      i,
      v,
      m,
      p,
      l,
      f,
      P,
      I,
      x,
      h,
      b,
      g,
      N,
      w
    ]), Ae(() => {
      if (!u || !i || !(C != null && C.isConnected) || !(K != null && K.isConnected)) return;
      const R = () => {
        C.style.zIndex = getComputedStyle(K).zIndex;
      };
      R();
      let $ = requestAnimationFrame(() => {
        $ = requestAnimationFrame(R);
      });
      return () => cancelAnimationFrame($);
    }, [u, i, C, K]);
    const z = v ? "fixed" : "absolute";
    return E = _e(
      E,
      (R) => /* @__PURE__ */ re(
        "div",
        L(F({}, s), {
          style: F({
            // https://floating-ui.com/docs/computeposition#initial-layout
            position: z,
            top: 0,
            left: 0,
            width: "max-content"
          }, s == null ? void 0 : s.style),
          ref: e == null ? void 0 : e.setPopoverElement,
          children: R
        })
      ),
      [e, z, s]
    ), E = _e(
      E,
      (R) => /* @__PURE__ */ re(lt, { value: e, children: R }),
      [e]
    ), E = L(F({
      // data-placing is not part of the public API. We're setting this here so
      // we can wait for the popover to be positioned before other components
      // move focus into it. For example, this attribute is observed by the
      // Combobox component with the autoSelect behavior.
      "data-placing": !D || void 0
    }, E), {
      style: F({
        position: "relative"
      }, E.style)
    }), E = St(L(F({
      store: e,
      modal: o,
      portal: a,
      preserveTabOrder: c,
      preserveTabOrderAnchor: A || U,
      autoFocusOnShow: D && d
    }, E), {
      portalRef: k
    })), E;
  }
);
wt(
  oe(function(r) {
    const n = rn(r);
    return se(qr, n);
  }),
  Ke
);
var nn = "span", on = {
  top: "4,10 8,6 12,10",
  right: "6,4 10,8 6,12",
  bottom: "4,6 8,10 12,6",
  left: "10,4 6,8 10,12"
}, sn = ne(function(r) {
  var n = r, { store: e, placement: o } = n, a = ee(n, ["store", "placement"]);
  const c = xr();
  e = e || c, pe(
    e,
    process.env.NODE_ENV !== "production" && "PopoverDisclosureArrow must be wrapped in a PopoverDisclosure component."
  );
  const s = e.useState((p) => o || p.placement).split("-")[0], v = on[s], m = rt(
    () => /* @__PURE__ */ re(
      "svg",
      {
        display: "block",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        viewBox: "0 0 16 16",
        height: "1em",
        width: "1em",
        children: /* @__PURE__ */ re("polyline", { points: v })
      }
    ),
    [v]
  );
  return a = L(F({
    children: m,
    "aria-hidden": !0
  }, a), {
    style: F({
      width: "1em",
      height: "1em",
      pointerEvents: "none"
    }, a.style)
  }), Fe(a);
}), Fn = oe(
  function(r) {
    const n = sn(r);
    return se(nn, n);
  }
);
const an = "_item_rr94j_3", Ge = {
  item: an
}, un = ({
  children: t,
  selected: r,
  disabled: n,
  className: e,
  ...o
}) => {
  const a = Zt(
    Ge.item,
    {
      [Ge.selected]: r
    },
    e
  );
  return /* @__PURE__ */ re(Qt, { className: a, "data-disabled": n, ...o, children: t });
};
un.displayName = "ListBoxItem";
export {
  or as C,
  un as L,
  Fn as P,
  st as a,
  Sn as b,
  Pn as c,
  wn as d,
  Cn as e,
  kr as f,
  hr as g,
  yn as h,
  En as i,
  hn as j,
  jr as k,
  Br as l,
  _n as m,
  Dn as n,
  bn as o,
  An as p,
  rn as q,
  ot as r,
  On as s,
  Ke as t,
  xn as u,
  lt as v,
  Sr as w,
  In as x,
  sn as y
};
//# sourceMappingURL=list-box-item.Brhznzvl.js.map
